module.exports = __webpack_public_path__ + "img/4a1204ebc4f9505cf7c4e5bd8895c0b6.e9658819.png";